import { createContext, useContext } from 'react'

export const ConnectModalContext = createContext<{
  isConnectModalOpen: boolean
  setConnectModalOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
}>(null as any)

export const useConnectModal = () => {
  const { isConnectModalOpen, setConnectModalOpen } = useContext(ConnectModalContext)
  return {
    isConnectModalOpen,
    setConnectModalOpen: () => setConnectModalOpen(true),
    setConnectModalClose: () => setConnectModalOpen(false),
    toggleConnectModal: () => setConnectModalOpen((visible) => !visible),
  }
}
